import Cookies from 'js-cookie'
import { userLogin, userUpdate } from "@/apis"
import {
    USER_SENDING_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_REQUEST_FAIL,
    USER_LOGOUT,
    USER_UPDATE_SUCCESS,
    USER_UPDATE_HAVE_PASSWORD_SUCCESS,
} from "../action-types/user"

import { USER_ROLES_INIT } from "../action-types/userRole"

export const userLoginRequest =
    ({ username, password }) =>
    async (dispatch, getState) => {
        dispatch({ type: USER_SENDING_REQUEST })
        try {
            const result = await userLogin({ username, password })
            dispatch({ type: USER_LOGIN_SUCCESS, payload: result.data })
            const { userReducer } = getState()
            window.localStorage.setItem("accessToken", JSON.stringify(userReducer.token))
            window.localStorage.setItem("refreshToken", JSON.stringify(result.data.refreshToken))
            window.localStorage.setItem("userInfo", JSON.stringify(userReducer.user))
            Cookies.set('accessToken', JSON.stringify(userReducer.token))
        } catch (error) {
            dispatch({ type: USER_REQUEST_FAIL, payload: error.data.message })
        }
    }

export const userFirstVisitProjectDashboard = (userId) => async (dispatch, getState) => {
    try {
        const dateProjectDashboardFirstVisit = new Date().toISOString().slice(0, 19).replace("T", " ")
        await updateUserExceptPassword({ userId, dateProjectDashboardFirstVisit }, dispatch, getState)
    } catch (error) {
        dispatch({ type: USER_REQUEST_FAIL, payload: error.data.data ? error.data.data.message : error.data.message })
    }
}

export const userUpdateRequest = (newUser) => async (dispatch, getState) => {
    dispatch({ type: USER_SENDING_REQUEST })
    try {
        const { password } = newUser
        if (password) {
            await userUpdate(newUser)
            dispatch({ type: USER_UPDATE_HAVE_PASSWORD_SUCCESS })
            window.localStorage.removeItem("accessToken")
            window.localStorage.removeItem("userInfo")
            window.localStorage.removeItem("refreshToken")
        } else {
            await updateUserExceptPassword(newUser, dispatch, getState)
        }
    } catch (error) {
        let errorMessage = null
        if (error.data) {
            if (error.data.data) errorMessage = error.data.data.message
            else errorMessage = error.data.message
        } else {
            errorMessage = error.message
        }
        dispatch({ type: USER_REQUEST_FAIL, payload: errorMessage })
    }
}

export const userLogoutRequest = (dispatch) => {
    dispatch({ type: USER_LOGOUT })
    dispatch({ type: USER_ROLES_INIT })
    window.localStorage.removeItem("accessToken")
    window.localStorage.removeItem("userInfo")
}

const updateUserExceptPassword = async (reqObj, dispatch, getState) => {
    const result = await userUpdate(reqObj)
    dispatch({ type: USER_UPDATE_SUCCESS, payload: result.data })
    const { userReducer } = getState()
    window.localStorage.setItem("userInfo", JSON.stringify(userReducer.user))

    /*
    result = await userUpdate({ dateProjectDashboardFirstVisit })
    dispatch({ type: USER_UPDATE_SUCCESS, payload: result.data })
    const { userReducer } = getState()
    window.localStorage.setItem("userInfo", JSON.stringify(userReducer.user))
    */

    /*
    result = await userUpdate({ userId, firstName, lastName, email })
    dispatch({ type: USER_UPDATE_SUCCESS, payload: result.data })
    const { userReducer } = getState()
    window.localStorage.setItem("userInfo", JSON.stringify(userReducer.user))
    */
}
